/**
 * APP获取用户信息
 * @returns {Function}
 */
// launchLogin
// getUserInfo
// zgLog
// launchAuth
const Handler = require('./ZGEventHandler');
window.ZGEventHandler = Handler.ZGEventHandler
export const getUserInfo = () => {
  return new Promise((resolve) => {
    if (/android/i.test(navigator.userAgent)) {
      console.log('android --- getUserInfo');
      window.ZGEventHandler.callAndroidNativeFunction('getUserInfo', null, 'getUserInfo', function (data) {
        console.log('android --- success --- getUserInfo', data);
        resolve(data)
      })
    } else if (/ios|iphone|ipod|pad/i.test(navigator.userAgent)) {
      console.log('ios --- getUserInfo', window);
      window.ZGEventHandler.callNativeFunction('getUserInfo', null, 'getUserInfo', function (data) {
        console.log('ios --- success ---  getUserInfo', data);
        resolve(data)
      })
    }
  })
};
export const compareImage = (url) => {
  return new Promise((resolve) => {
    if (/android/i.test(navigator.userAgent)) {
      console.log('android --- compareImage');
      window.ZGEventHandler && window.ZGEventHandler.callAndroidNativeFunction('compareImage', url, url, function (data) {
        console.log('android --- success --- compareImage', data);
        resolve(data)
      })
    } else if (/ios|iphone|ipod|pad/i.test(navigator.userAgent)) {
      console.log('ios --- compareImage');
      window.ZGEventHandler && window.ZGEventHandler.callNativeFunction('compareImage', url, 'compareImage', function (data) {
        console.log('ios --- success --- 222 ---compareImage', data);
        resolve(data)
      })
    }
  })
};
/**
 * APP记录日志
 * @returns {Function}
 */
export const zgLog = (log) => {
  try {
    if (/android/i.test(navigator.userAgent)) {
      console.log('android --- zgLog');
      window.ZGWebBridgeManager.zgLog(log);
    } else if (/ios|iphone|ipod|pad/i.test(navigator.userAgent)) {
      console.log('ios --- zgLog');
      window.webkit && window.webkit.messageHandlers.ZGEventHandler.postMessage({
        methodName: 'zgLog',
        params: log,
      });
    }
  } catch (e) {
    console.log(e)
  }
};
/**
 * APP去登陆页面
 * @returns {Function}
 */
export const launchLogin = () => {
  if (/android/i.test(navigator.userAgent)) {
    console.log('android --- launchLogin');
    window.ZGWebBridgeManager.launchLogin();
  } else if (/ios|iphone|ipod|pad/i.test(navigator.userAgent)) {
    console.log('ios --- launchLogin');
    window.webkit && window.webkit.messageHandlers.ZGEventHandler.postMessage({
      methodName: 'launchLogin'
    });
  }
};
/**
 * APP去认证页面
 * @returns {Function}
 */
export const launchAuth = (url) => {
  if (/android/i.test(navigator.userAgent)) {
    console.log('android --- launchAuth');
    window.ZGWebBridgeManager.launchAuth(url);
  } else if (/ios|iphone|ipod|pad/i.test(navigator.userAgent)) {
    console.log('ios --- launchAuth');
    window.webkit && window.webkit.messageHandlers.ZGEventHandler.postMessage({
      methodName: 'launchAuth',
      params: url
    });
  }
};
/**
 * token失效，弹窗
 * @returns {Function}
 */
export const sessionInvalid = () => {
  if (/android/i.test(navigator.userAgent)) {
    console.log('android --- sessionInvalid');
    window.ZGWebBridgeManager.sessionInvalid();
  } else if (/ios|iphone|ipod|pad/i.test(navigator.userAgent)) {
    console.log('ios --- sessionInvalid');
    window.webkit && window.webkit.messageHandlers.ZGEventHandler.postMessage({
      methodName: 'sessionInvalid',
    });
  }
};
/**
 * 跳转订单支付页面
 * @returns {Function}
 */
export const launchOrderPayPage = (orderInfo) => {
  if (/android/i.test(navigator.userAgent)) {
    console.log('android --- launchOrderPayPage');
    window.ZGWebBridgeManager.launchOrderPayPage(orderInfo);
  } else if (/ios|iphone|ipod|pad/i.test(navigator.userAgent)) {
    console.log('ios --- launchOrderPayPage');
    window.webkit && window.webkit.messageHandlers.ZGEventHandler.postMessage({
      methodName: 'launchOrderPayPage',
      params: orderInfo
    });
  }
};
/**
 *  刷新native用户信息
 * @returns {Function}
 */
export const refreshNativeUserinfo = () => {
  if (/android/i.test(navigator.userAgent)) {
    console.log('android --- refreshNativeUserinfo');
    window.ZGWebBridgeManager.refreshNativeUserinfo();
  } else if (/ios|iphone|ipod|pad/i.test(navigator.userAgent)) {
    console.log('ios --- refreshNativeUserinfo');
    window.webkit && window.webkit.messageHandlers.ZGEventHandler.postMessage({
      methodName: 'refreshNativeUserinfo'
    });
  }
};


/**
 * 调用原生相机
 * @returns {Promise}
 */
export const showPictureSelector = () => {
  window.ZGEventHandler.removeCallBack('showPictureSelector')
  return new Promise((resolve) => {
    if (/android/i.test(navigator.userAgent)) {
      // index++
      window.ZGEventHandler.callAndroidNativeFunction('showPictureSelector', null, 'showPictureSelector', function (data) {
        console.log('android1 --- success --- showPictureSelector', data);
        resolve(data)
      })
    } else if (/ios|iphone|ipod|pad/i.test(navigator.userAgent)) {
      console.log('start showPictureSelector iphone')
      window.ZGEventHandler.callNativeFunction('showPictureSelector', null, 'showPictureSelector', function (data) {
        console.log('ios2 --- success ---  showPictureSelector', data);
        resolve(data)
      })
    }
  })
};

/**
 * 启动二维码扫码
 * @returns {Promise}
 */
export const startScan = () => {
  console.log('start startScan   ', /ios|iphone|ipod|pad/i.test(navigator.userAgent))
  window.ZGEventHandler.removeCallBack('startScan')
  return new Promise((resolve) => {
    if (/android/i.test(navigator.userAgent)) {
      // index++
      window.ZGEventHandler.callAndroidNativeFunction('startScan', null, 'startScan', function (data) {
        console.log('android1 --- success --- startScan', data);
        resolve(data)
      })
    } else if (/ios|iphone|ipod|pad/i.test(navigator.userAgent)) {
      // index++
      console.log('start startScan sss')
      window.ZGEventHandler.callNativeFunction('startScan', null, 'startScan', function (data) {
        console.log('ios2 --- success ---  startScan', data);
        resolve(data)
      })
    }
  })
}

/**
 * 复制剪切板
 * @param {string} str 复制内容
 */
 export const writeToPasteboard = (str) => {
  console.log('开始  android --- writeToPasteboard');
  if (/android/i.test(navigator.userAgent)) {
    console.log('android --- writeToPasteboard');
    window.ZGWebBridgeManager.writeToPasteboard(str);
  } else if (/ios|iphone|ipod|pad/i.test(navigator.userAgent)) {
    console.log('ios --- writeToPasteboard');
    window.webkit && window.webkit.messageHandlers.ZGEventHandler.postMessage({
      methodName: 'writeToPasteboard',
      params: str
    });
  }
}

/**
 * 
 * @param {string} id 请求参数
 * @returns promise 回调参数
 */
export const canUserEnrollExam = (id = null) => {
  window.ZGEventHandler.removeCallBack('canUserEnrollExam')
  return new Promise((resolve) => {
    if (/android/i.test(navigator.userAgent)) {
      // index++
      window.ZGEventHandler.callAndroidNativeFunction('canUserEnrollExam', null, 'canUserEnrollExam', function (data) {
        console.log('android1 --- success --- canUserEnrollExam', data);
        resolve(data)
      })
    } else if (/ios|iphone|ipod|pad/i.test(navigator.userAgent)) {
      // index++
      console.log('start canUserEnrollExam sss')
      window.ZGEventHandler.callNativeFunction('canUserEnrollExam', null, 'canUserEnrollExam', function (data) {
        console.log('ios2 --- success ---  canUserEnrollExam', data);
        resolve(data)
      })
    }
  })
}

/**
 * 调用原生方法返回
 */
export const goBackNative = () => {
  if (/android/i.test(navigator.userAgent)) {
    console.log('android --- goBackNative');
    window.ZGWebBridgeManager.goBackNative();
  } else if (/ios|iphone|ipod|pad/i.test(navigator.userAgent)) {
    console.log('ios --- goBackNative');
    window.webkit && window.webkit.messageHandlers.ZGEventHandler.postMessage({
      methodName: 'goBackNative'
    });
  }
}

/**
 * 跳转至首页
 */
 export const exit = () => {
  if (/android/i.test(navigator.userAgent)) {
    console.log('android --- exit');
    window.ZGWebBridgeManager.exit();
  } else if (/ios|iphone|ipod|pad/i.test(navigator.userAgent)) {
    console.log('ios --- exit');
    window.webkit && window.webkit.messageHandlers.ZGEventHandler.postMessage({
      methodName: 'exit'
    });
  }
}
